import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/Login";
import Dashboard from "../views/Dashboard";
import Users from "../views/Users";
import TelegramTest from "../views/TelegramTest";
import TelegramAuth from "../views/TelegramAuth";
import HelpDesk from "@/views/HelpDesk/HelpDesk";
import Trades from "@/views/Trades/Trades";
import Payments from "@/views/Payments/Payments";
import Coupons from "@/views/Coupons/Coupons";
import Backlog from "@/views/Backlog/Backlog";
import Clubs from "@/views/Clubs/Clubs";
import MetaCredentials from "@/views/MetaCredentials/MetaCredentials";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
    },
    {
        path: '/trades',
        name: 'trades',
        component: Trades,
        props: true,
    },
    {
        path: '/help-desk',
        name: 'Help-desk',
        component: HelpDesk,
    },
    {
        path: '/payments',
        name: 'Payments',
        component: Payments,
    },
    {
        path: '/coupons',
        name: 'Coupons',
        component: Coupons,
    },
    {
        path: '/meta-credentials',
        name: 'MetaCredentials',
        component: MetaCredentials,
    },
    {
        path: '/backlog',
        name: 'Backlog',
        component: Backlog,
    },
    {
        path: '/clubs',
        name: 'Clubs',
        component: Clubs,
    },
    {
        path: '/telegram',
        name: 'Telegram',
        component: TelegramTest,
    },
    {
        path: '/telegramauth',
        name: 'TelegramAuth',
        component: TelegramAuth,
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
